import React from 'react';
import { AppEmbedPage } from '../components/Embed/fullAppEmbed';
import { SearchEmbedPage } from '../components/Embed/searchEmbed';
import { LiveboardEmbedPage } from '../components/Embed/liveboardEmbed';
import { VizEmbedPage } from '../components/Embed/vizEmbed';
import { SpotterEmbedPage } from '../components/Embed/spotterEmbed';

export const route = (
  route: string,
  embedSelections = {},
  setEmbedSelections: (embedSelections: any) => void
) => {
  switch (route) {
    case '/search':
      return (
        <SearchEmbedPage
          embedSelections={embedSelections}
          setEmbedSelections={setEmbedSelections}
        />
      );
    case '/home':
      return (
        <AppEmbedPage embedSelections={embedSelections} setEmbedSelections={setEmbedSelections} />
      );
    case '/viz':
      return (
        <VizEmbedPage embedSelections={embedSelections} setEmbedSelections={setEmbedSelections} />
      );
    case '/spotter':
      return (
        <SpotterEmbedPage
          embedSelections={embedSelections}
          setEmbedSelections={setEmbedSelections}
        />
      );
    default:
      return (
        <LiveboardEmbedPage
          embedSelections={embedSelections}
          setEmbedSelections={setEmbedSelections}
        />
      );
  }
};
